import React from 'react'
import styled from 'styled-components'
import Layout from '../layouts'
import SEO from '../components/seo'
import BG from "../components/bg"
import BrandInfo from '../components/infoSection';
import Offer from '../components/offerSection';
import Contact from '../components/contact';
import 'bootstrap/dist/css/bootstrap.css';
import Background from '../images/ver2.jpg'

// ===== STYLED COMPONENTS =====

const StyledBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.buttonBorder};
`;

const BGImage = styled.div`
  position: relative;
  width: 100%;
  min-height: 80vh; /* dynamicznie dopasowuje się do ekranu */
  overflow: hidden;
  background-color: black;

  img {
    width: 100%;
    height: auto;
    object-fit: contain; /* ✅ cały obraz widoczny, nic nie przycięte */
    object-position: center;
    display: block;
  }

  @media (max-width: 960px) {
    min-height: 60vh;
  }

  @media (max-width: 600px) {
    min-height: 30vh;
    margin-top: 80px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.35;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 1200px;
  text-align: center;
  color: white;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1.5rem;
  font-weight: 700;

  @media (max-width: 960px) {
    font-size: 2.2rem;
  }

  @media (max-width: 600px) {
    font-size: 1.8rem;
  }
`;

const SubTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 400;
  margin-bottom: 2rem;

  @media (max-width: 960px) {
    font-size: 1.4rem;
  }

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`;

const StyledTradeLink = styled.a`
  display: inline-block;
  font-weight: 600;
  letter-spacing: 2px;
  text-transform: uppercase;
  cursor: pointer;
  font-size: 1rem;
  padding: 1rem 1.7rem;
  background: linear-gradient(90deg, rgba(116,115,115,1) 0%, rgba(76,74,74,1) 31%);
  color: white;
  text-decoration: none;
  border: 1px solid transparent;
  box-shadow: ${({ theme }) => theme.shadows.small};
  transition: all 0.3s ease;

  :hover,
  :focus {
    border: 1px solid white;
    color: white;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

// ===== FUNKCJA SKROLLUJĄCA =====

const scrollToBottom = () => {
  window.scrollTo({
    top: document.documentElement.scrollHeight,
    behavior: 'smooth',
  });
};

// ===== GŁÓWNY KOMPONENT =====

const IndexPage = (props) => {
  return (
    <Layout path={props.location.pathname}>
      <SEO 
        title='Projekty wnętrz' 
        path={props.location.pathname} 
        description='Horyzont domu' 
      />
      <BG />
      <StyledBody>
        <BGImage>
          <img src={Background} alt="Tło sekcji hero" />
          {/* <Overlay /> */}
          {/* <ContentWrapper>
            <Title>Projektujemy wnętrza, które inspirują</Title>
            <SubTitle>Tworzymy przestrzenie, w których chce się żyć</SubTitle>
            <ButtonWrapper>
              <StyledTradeLink onClick={scrollToBottom}>
                Napisz do nas
              </StyledTradeLink>
            </ButtonWrapper>
          </ContentWrapper> */}
        </BGImage>

        <Offer />
        <BrandInfo />
        <Contact />
      </StyledBody>
    </Layout>
  );
};

export default IndexPage;
